import React, { Component } from 'react'
import { connect } from 'react-redux'
import withRouter from 'react-router/withRouter'
import ThanksPage from '../points-purchase/components/thanks-page.component'

class PurchaseSuccessPage extends Component {
	render() {
		return <ThanksPage />
	}
}

const ConnectedPurchaseSuccessPage = withRouter(
	connect(null)(PurchaseSuccessPage)
)

export { ConnectedPurchaseSuccessPage as ModuleRootComponent }
